const currencies={
    "AR":"ARS",
    "CO": "COP",
    "CL": "CLP",
    "PE":"PEN",
    "EC": "USD",
    "GT": "GTQ",
    "MX":"MXN",
    "US": "US",
}
export default currencies